export default class TimesheetsSummaryClientViewModel {
  constructor({
    clientId = 0,
    clientName = '',
    approvedCount = 0,
    pendingReviewCount = 0,
    pendingApprovalCount = 0,
  } = {}) {
    /**
     * @type {Number}
     */
    this.clientId = clientId
    /**
     * @type {String}
     */
    this.clientName = clientName
    /**
     * @type {Number}
     */
    this.approvedCount = approvedCount
    /**
     * @type {Number}
     */
    this.pendingReviewCount = pendingReviewCount
    /**
     * @type {Number}
     */
    this.pendingApprovalCount = pendingApprovalCount
  }
}
